// Generated by Melange

import * as Fx from "../../fx/fx.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Subsonic__Empty from "./empty.jsx";
import * as Subsonic__Utils from "./utils.jsx";

function make(id, current, positionOpt, param) {
  const position = positionOpt !== undefined ? positionOpt : 0.0;
  const params = {};
  return Fx.Monad_syntax.let$star((params["id"] = {
    TAG: /* Array */ 0,
    _0: id
  }, Stdlib__Option.iter((function (current) {
    params["current"] = {
      TAG: /* Value */ 1,
      _0: current
    };
  }), current), params["position"] = {
    TAG: /* Value */ 1,
    _0: position.toString(undefined)
  }, Subsonic__Utils.makeRequest({
    _method: "rest/savePlayQueue",
    params: params
  }, Subsonic__Empty.of_json)), (function (param) {
    return {
      TAG: /* Ok */ 0,
      _0: undefined
    };
  }));
}

export {
  make,
}
/* No side effect */
